/**
 * Modular What's New entries for the "delegation" module: the "Delegated to" filter of the
 * management lists. `routes` use the real navigation screen name from AppNavigator.jsx: the lists
 * are the shared `ManagementListScreen` opened with `params.type`.
 *
 * @type {Object[]}
 */
const delegationEntries = [
  {
    id: 'delegation-filter-lists-2026-10',
    module: 'delegation',
    routes: [
      { screen: 'ManagementListScreen', params: { type: 'tasks' } },
      { screen: 'ManagementListScreen', params: { type: 'projects' } },
      { screen: 'ManagementListScreen', params: { type: 'leads' } },
    ],
    date: '2026-10-18',
    version: '4.15.1',
    global: true,
    type: 'feature',
    title: {
      en: "🎯 Filter by who it is delegated to",
      hu: "🎯 Szűrés arra, hogy kire van delegálva",
      de: "🎯 Filtern nach der zuständigen Person",
      cn: "🎯 按委派对象筛选",
      ro: "🎯 Filtrare după persoana căreia i-a fost delegat",
      svn: "🎯 Filtriranje po tem, komu je delegirano",
    },
    body: {
      en: "Finding your own work in a long list of leads, tasks and projects meant scrolling through everyone's items. The lists now have a Delegated to filter: show only what is yours, only what has not been delegated to anybody yet, or only what belongs to a colleague you pick. The filter narrows the whole list, not just the rows already loaded.",
      hu: "Ha a saját munkádat kerested a leadek, feladatok és projektek hosszú listájában, mindenki tételei között kellett görgetned. A listákon mostantól van Delegálva szűrő: megmutathatod csak a sajátjaidat, csak azokat, amelyek még senkire sincsenek delegálva, vagy csak egy kiválasztott kolléga tételeit. A szűrő a teljes listára hat, nem csak a már betöltött sorokra.",
      de: "Wer die eigene Arbeit in einer langen Liste aus Leads, Aufgaben und Projekten suchte, musste durch die Einträge aller scrollen. Die Listen haben jetzt einen Filter „Delegiert an“: Zeigen Sie nur Ihre eigenen Einträge, nur solche, die noch niemandem zugewiesen sind, oder nur die einer ausgewählten Kollegin oder eines Kollegen. Der Filter wirkt auf die gesamte Liste, nicht nur auf die bereits geladenen Zeilen.",
      cn: "以前要在很长的潜在客户、任务和项目列表中找到自己的工作，只能翻看所有人的条目。现在列表新增“委派给”筛选：只看属于你的、只看尚未委派给任何人的，或只看你选择的某位同事的条目。筛选作用于整个列表，而不仅是已加载的行。",
      ro: "Ca să găsiți propria muncă într-o listă lungă de lead-uri, sarcini și proiecte, trebuia să parcurgeți elementele tuturor. Listele au acum filtrul Delegat către: afișați doar ce este al dumneavoastră, doar ce nu a fost încă delegat nimănui sau doar elementele unui coleg ales. Filtrul se aplică întregii liste, nu doar rândurilor deja încărcate.",
      svn: "Kdor je v dolgem seznamu potencialnih kupcev, nalog in projektov iskal svoje delo, je moral listati med elementi vseh. Seznami zdaj vsebujejo filter Delegirano na: prikažite samo svoje elemente, samo tiste, ki še niso delegirani nikomur, ali samo elemente izbranega sodelavca. Filter velja za celoten seznam, ne le za že naložene vrstice.",
    },
  },
];

export default delegationEntries;
